module.exports = __webpack_public_path__ + "img/Katia2.6064676e.png";